export default "__VITE_ASSET__3pSbL6aQ__"